import { queryToJson } from '@/lib/tools';
import dao from '@/dao';

function isUgc(url) {
    let arr = url.split('?');
    let rules = ['upload.ugc', 'upload-ugc'];
    let res = rules.some(key => {
        return arr[0].indexOf(key) !== -1;
    })
    return res;
}
const ERROR_DATA = {
    error: true,
    message: '解析预览地址失败'
};

function parsePreviewUrl(url) {
    let queries;
    let arr = (url || '').split('?');
    let host = arr[0];

    if(arr.length > 1) {
        queries = queryToJson(arr[1]);
    }
    
    if(queries) {
        if(host.slice(-1) !== '/') {
            host += '/';
        }
        let index = Number(queries.pageIndex) || 1;
        let count = Number(queries.pageCount) || 0;
        if(index > count) {
            index = count;
        }
        return {
            'url': host + queries.prefix,
            'pageCount': count,
            'pageIndex': index
        }
    }
    return null;
}


function getPreviewUrl() {
    let queries = queryToJson();
    let url = decodeURIComponent(queries.url || '');
    
    return new Promise((resolve, reject) => {
        if(isUgc(url)) {
            dao.x({
                name: 'getPreviewUrl',
                uri: url
            }).then(res => {
                let data = parsePreviewUrl(res.location);
                if(data) {
                    resolve(data);
                } else {
                    resolve(ERROR_DATA);
                }
               
            }).catch(err => {
                reject({
                    ...ERROR_DATA,
                    data: err
                });
            });
        } else {
            let data = parsePreviewUrl(url);
            if(data) {
                resolve(data);
            } else {
                resolve(ERROR_DATA);
            }
        }    
    });
}

export {
    getPreviewUrl
}
